// WP Babotics
// vert de background : #174a58
// Couleur des liens : #2ebcfc

const baboticsGreen = `#2c8faa`
// const indigoLight = `#7d99d8`
// const grey90 = `#0d2931`
const baboticsGreenDark = `#123a45`
const black80 = `#1B1F23`
const white = `#fff`
const lightWhite = `rgba(255, 255, 255, 0.86)`
// const opaqueLightIndigo = `rgba(86, 122, 205, 0.2)`
const opaqueLightBaboticsGreen = `rgba(44, 143, 170, 0.2)`
const opaqueLightWhite = `hsla(0, 0%, 100%, 0.3)`
const lightGray = `hsla(0, 0%, 0%, 0.2)`

export default {
  text: baboticsGreenDark,
  background: white,
  primary: baboticsGreen,
  secondary: black80,
  muted: lightGray,
  highlight: opaqueLightBaboticsGreen,
  heading: baboticsGreenDark,
  prism: {
    background: `#15171e`,
    comment: `#809393`,
    string: `#addb67`,
    var: `#d6deeb`,
    number: `#f78c6c`,
    constant: `#82aaff`,
    punctuation: `#c792ea`,
    className: `#ffc98b`,
    tag: `#ffa7c4`,
    boolean: `#ff5874`,
    property: `#80cbc4`,
    namespace: `#b2ccd6`,
    highlight: `hsla(207, 95%, 15%, 1)`,
  },
  modes: {
    dark: {
      text: lightWhite,
      background: baboticsGreenDark,
      // primary: indigoLight,
      primary: baboticsGreen,
      secondary: lightWhite,
      muted: opaqueLightWhite,
      // highlight: indigo,
      highlight: opaqueLightBaboticsGreen,
      heading: white,
    },
  },
}
